import { Action, createReducer, on } from '@ngrx/store';
import { Consent, Country } from '@shared/interfaces';
import { loadCountries, addCountries, loadFailure, loadConsents, addConsents } from './datalists.actions';

export const featureKey = 'datalists';

export interface State {
  countries: Country[],
  consents: {[key in string]: Consent};
  loading: boolean;
  error: string;
}

export const initialState: State = {
  countries: [],
  consents: undefined,
  loading: undefined,
  error: undefined
};

const _reducer = createReducer(
  initialState,
  on(loadCountries, (state) => ({
    ...state,
    loading: true
  })),
  on(addCountries, (state, { countries }) => ({
    ...state,
    loading: false,
    countries: [...countries]
  })),
  on(loadConsents, (state) => ({
    ...state,
    loading: true
  })),
  on(addConsents, (state, { consents }) => ({
    ...state,
    loading: false,
    consents: {...consents}
  })),
  on(loadFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return _reducer(state, action);
}

